export default __webpack_public_path__ + "static/media/house.fe345697.svg";